import * as React from "react";
import { Monitor, Shield, Activity, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const solutions = [{
  title: "Szálláskereső",
  description: "Hasonlítsa össze a legjobb hotel ajánlatokat világszerte. Találja meg a tökéletes pihenőhelyet a legkedvezőbb áron, legyen szó luxusról vagy pénztárcabarát megoldásról.",
  icon: Monitor
}, {
  title: "Repülőjegyek",
  description: "Gyors és megbízható járatkereső rendszerünkkel pillanatok alatt lefoglalhatja repülőjegyét bármely úticélhoz, rejtett költségek nélkül.",
  icon: Shield
}, {
  title: "Taxi & Transzfer",
  description: "Érkezzen meg kényelmesen és biztonságosan. Foglaljon előre taxit vagy reptéri transzfert, hogy az utazás utolsó szakasza is zökkenőmentes legyen.",
  icon: Activity
}];
export default function Software() {
  return <section data-section-id="229003" id="searchwidget" className="bg-background text-foreground py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight sm:text-4xl text-foreground">
            Foglaljon Mindent Egy Helyen
          </h2>
          <p className="font-default mt-4 text-lg leading-8 text-muted-foreground">
            Használja integrált keresőmotorunkat a legfrissebb utazási ajánlatok eléréséhez. Gyors, biztonságos és átlátható foglalási folyamat.
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-12 gap-6 sm:mt-20 lg:max-w-none">
          <div id="search-widget-container" className="col-span-12 mb-8">
            <script async src="https://tpwidg.com/content?currency=USD&trs=523773&shmarker=721908&language=en&theme=8&powered_by=true&campaign_id=1&promo_id=1486" charset="utf-8"></script>
          </div>

          {solutions.map((solution, i) => <div key={i} data-index={i} className="col-span-12 md:col-span-6 lg:col-span-4">
              <Card className="h-full border-border bg-card shadow-sm transition-shadow hover:shadow-md rounded-lg">
                <CardHeader>
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-md bg-accent">
                    <solution.icon className="h-6 w-6 text-accent-foreground" strokeWidth={1.5} aria-hidden="true" />
                  </div>
                  <CardTitle className="font-default text-xl font-semibold text-card-foreground">
                    {solution.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-default text-base leading-relaxed text-muted-foreground">
                    {solution.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Button variant="default" size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg" asChild>
            <Link to="/AccommodationsPage">
              Kezdje el a keresést
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}